import FloatLabels from 'float-labels.js';
import TomSelect from 'tom-select';

// global.js
// > Ce fichier contient des scripts JavaScript globaux pour le site.
// - Créé le : 08/09/2026 12:51:19
// - Serveur  : ubuntu240401
// - Template : /donnee/d_www/site/rucherdelavilaine/site/www.lerucherdelavilaine.fr/web/modules/b2icontrib/b2ibase/templates/Command/InitThemeCommand/execute/src/js/global.js.twig

/**
 * @file
 * Global utilities.
 *
 */
(function (Drupal, drupalSettings) {
	'use strict';
	Drupal.behaviors.rucherdelavilaine_theme_theme = {
		attach: function (context, settings) {
			once('main', 'body', context).forEach(function () {
				webformMediaBleed();
			});
			initBareCkeditorAccordions(context);
			// Rejoue après rebuild AJAX webform (erreurs de validation).
			initWebformSkin(context);
			initCartForm(context);
		}
	};

	/**
	 * once() ne matche pas le context s'il est lui-même la cible (cas AJAX webform).
	 */
	function onceInContext(id, selector, context) {
		const scoped = context && context.nodeType === 1;
		const root = scoped ? (context.parentNode || document) : document;
		return once(id, selector, root).filter(function (el) {
			if (!scoped) {
				return true;
			}
			return el === context || context.contains(el);
		});
	}

	function initBareCkeditorAccordions(context) {
		once('rucherdelavilaine-bare-accordion', '.ckeditor-accordion-container > dl:not(.styled):not(.ckeditor-accordion)', context).forEach(function (dl) {
			Array.prototype.forEach.call(dl.querySelectorAll(':scope > dt'), function (dt) {
				dt.addEventListener('click', function () {
					const dd = dt.nextElementSibling;
					const isOpen = dt.classList.contains('active');
					Array.prototype.forEach.call(dl.querySelectorAll(':scope > .active'), function (el) {
						el.classList.remove('active');
						if (el.tagName === 'DD') {
							el.style.display = 'none';
						}
					});
					if (!isOpen && dd && dd.tagName === 'DD') {
						dt.classList.add('active');
						dd.classList.add('active');
						dd.style.display = 'block';
					}
				});
			});
		});
	}

	function initWebformSkin(context) {
		floatLabels(context);
		select(context);
		webformDateFilled(context);
		webformRelocateAlert(context);
	}

	function select(context) {
		onceInContext('rucherdelavilaine_theme-tom-select', 'form.webform-submission-form select.form-select, form[id^="webform"] select.form-select', context).forEach(function (el) {
			if (el.tomselect) {
				return;
			}
			const wrap = el.closest('.fl-wrap-select');
			const formItem = el.closest('.form-item, .js-form-item');
			const labelEl = (wrap && wrap.querySelector('label.fl-label'))
				|| (formItem && formItem.querySelector('label'));
			const emptyLabel = (labelEl && labelEl.textContent.trim())
				|| (el.options.length && el.options[0].text.trim())
				|| '';
			const emptyLabelDisplay = withRequiredStar(emptyLabel, el, true);
			const emptyValue = ensureSelectPlaceholderOption(el, emptyLabelDisplay);
			if (el.classList.contains('error') || el.getAttribute('aria-invalid') === 'true') {
				el.value = emptyValue;
			}
			const instance = new TomSelect(el, {
				allowEmptyOption: true,
				maxOptions: null,
				hideSelected: false,
				controlInput: null,
				placeholder: emptyLabelDisplay
			});
			if (el.classList.contains('error') || el.getAttribute('aria-invalid') === 'true' || el.closest('.form-item--error')) {
				instance.wrapper.classList.add('error');
			}
			const syncFloat = function () {
				syncSelectFloatLabel(el, instance, emptyValue);
			};
			instance.on('change', syncFloat);
			instance.on('dropdown_close', syncFloat);
			syncFloat();
		});
	}

	function ensureSelectPlaceholderOption(el, emptyLabel) {
		const normalize = function (str) {
			return String(str || '')
				.replace(/\u00a0/g, ' ')
				.replace(/\s*\*$/, '')
				.trim();
		};
		const labelNorm = normalize(emptyLabel);
		let keptEmpty = null;
		Array.prototype.slice.call(el.options).forEach(function (opt) {
			const valNorm = normalize(opt.value);
			const textNorm = normalize(opt.text);
			const isEmptyValue = opt.value === '';
			const isBogusPlaceholder = !isEmptyValue && (
				valNorm === textNorm
				|| (labelNorm && (valNorm === labelNorm || textNorm === labelNorm))
				|| valNorm.indexOf('?') !== -1
			);
			if (isBogusPlaceholder) {
				opt.remove();
				return;
			}
			if (isEmptyValue) {
				if (keptEmpty) {
					opt.remove();
					return;
				}
				keptEmpty = opt;
			}
		});
		let emptyOpt = keptEmpty;
		if (!emptyOpt) {
			emptyOpt = document.createElement('option');
			emptyOpt.value = '';
			el.insertBefore(emptyOpt, el.firstChild);
		}
		if (emptyLabel) {
			emptyOpt.text = emptyLabel;
		}
		return '';
	}

	function syncSelectFloatLabel(el, instance, emptyValue) {
		const wrap = el.closest('.fl-wrap-select');
		if (!wrap) {
			return;
		}
		const value = instance.getValue();
		const isPlaceholder = value === '' || value === emptyValue;
		wrap.classList.toggle('is-placeholder', isPlaceholder);
		wrap.classList.toggle('fl-is-active', !isPlaceholder);
	}

	function webformDateFilled(context) {
		const selector = [
			'.webform-submission-form input[type="date"]',
			'.webform-submission-form input[type="datetime-local"]',
			'.webform-submission-form input[type="month"]',
			'.webform-submission-form input[type="week"]',
			'.webform-submission-form input[type="time"]',
			'.webform-submission-form input.form-date',
			'form[id^="webform"] input[type="date"]',
			'form[id^="webform"] input[type="datetime-local"]',
			'form[id^="webform"] input[type="month"]',
			'form[id^="webform"] input[type="week"]',
			'form[id^="webform"] input[type="time"]',
			'form[id^="webform"] input.form-date',
		].join(',');

		onceInContext('rucherdelavilaine_theme-webform-date-filled', selector, context).forEach(function (el) {
			const sync = function () {
				const filled = Boolean(el.value && String(el.value).trim());
				el.classList.toggle('is-filled', filled);
				el.toggleAttribute('data-wf-filled', filled);
				if (filled) {
					el.setAttribute('value', el.value);
				}
				else {
					el.removeAttribute('value');
				}
				const item = el.closest('.form-item, .js-form-item, .webform-type-date, .js-form-type-date');
				if (item) {
					item.classList.toggle('is-filled', filled);
					item.toggleAttribute('data-wf-filled', filled);
				}
			};
			el.addEventListener('change', sync);
			el.addEventListener('input', sync);
			el.addEventListener('blur', sync);
			sync();
		});
	}

	function withRequiredStar(text, el, forPlaceholder) {
		if (!text) {
			return text;
		}
		const required = el.hasAttribute('required') || el.classList.contains('required');
		const cleaned = String(text).replace(/\s*\*$/, '').trim();
		if (!required) {
			return cleaned;
		}
		return forPlaceholder ? cleaned + '\u00A0*' : cleaned;
	}

	function floatLabels(context) {
		const options = {
			style: 1,
			transform: 'input, select, textarea',
			exclude: '.no-label,[type="checkbox"],[type="radio"],[type="submit"],[type="button"],[type="hidden"],[type="file"],[type="image"]',
			customLabel: function (labelEl, el) {
				return withRequiredStar(labelEl.textContent, el, false);
			},
			customPlaceholder: function (placeholderText, el) {
				return withRequiredStar(placeholderText, el, true);
			},
		};
		onceInContext('rucherdelavilaine_theme-float-labels', 'form.webform-submission-form', context).forEach(function (form) {
			new FloatLabels(form, options);
		});
	}

	function webformRelocateAlert(context) {
		const message = Drupal.t("Vous n'avez pas rempli tous les champs obligatoires");
		const root = (context && context.nodeType === 1) ? context : document;
		const forms = [];
		if (root.matches && root.matches('form.webform-submission-form')) {
			forms.push(root);
		}
		if (root.querySelectorAll) {
			root.querySelectorAll('form.webform-submission-form').forEach(function (form) {
				if (forms.indexOf(form) === -1) {
					forms.push(form);
				}
			});
		}
		forms.forEach(function (form) {
			const actions = form.querySelector('.form-actions, .webform-actions');
			if (!actions) {
				return;
			}
			const hasErrors = Boolean(form.querySelector(
				'.form-item--error, fieldset.error, input.error, select.error, textarea.error, .alert-danger, .alert-error'
			));
			form.querySelectorAll('.alert, [role="alert"]').forEach(function (el) {
				if (!actions.contains(el)) {
					el.hidden = true;
					el.setAttribute('aria-hidden', 'true');
				}
			});
			let globalError = actions.querySelector('.webform-global-error');
			if (!hasErrors) {
				if (globalError) {
					globalError.remove();
				}
				return;
			}
			if (!globalError) {
				globalError = document.createElement('p');
				globalError.className = 'webform-global-error';
				globalError.setAttribute('role', 'alert');
				actions.appendChild(globalError);
			}
			globalError.textContent = message;
		});
	}

	function initCartForm(context) {
		once('rucher-cart-qty', '.commerce-cart-page .quantity-edit-input', context).forEach(function (input) {
			enhanceCartQuantity(input);
			let timer = null;
			const scheduleUpdate = function () {
				window.clearTimeout(timer);
				timer = window.setTimeout(function () {
					const form = input.closest('form');
					if (!form) {
						return;
					}
					const submit = form.querySelector('#edit-submit, input[data-drupal-selector="edit-submit"]');
					if (!submit) {
						return;
					}
					// POST classique (Chai d'Anthon) : totaux + stock cohérents après reload.
					if (typeof form.requestSubmit === 'function') {
						form.requestSubmit(submit);
					}
					else {
						submit.click();
					}
				}, 400);
			};
			input.addEventListener('change', scheduleUpdate);
		});
	}

	function enhanceCartQuantity(input) {
		const wrap = document.createElement('div');
		wrap.className = 'qty-stepper';
		input.parentNode.insertBefore(wrap, input);
		wrap.appendChild(input);

		const minus = document.createElement('button');
		minus.type = 'button';
		minus.className = 'qty-stepper__btn qty-stepper__btn--minus';
		minus.setAttribute('aria-label', Drupal.t('Diminuer la quantité'));
		const plus = document.createElement('button');
		plus.type = 'button';
		plus.className = 'qty-stepper__btn qty-stepper__btn--plus';
		plus.setAttribute('aria-label', Drupal.t('Augmenter la quantité'));

		wrap.insertBefore(minus, input);
		wrap.appendChild(plus);

		minus.addEventListener('click', function () {
			const min = parseInt(input.min || '1', 10);
			input.value = Math.max(min, (parseInt(input.value, 10) || min) - 1);
			input.dispatchEvent(new Event('change', { bubbles: true }));
		});
		plus.addEventListener('click', function () {
			const max = input.max ? parseInt(input.max, 10) : 99;
			input.value = Math.min(max, (parseInt(input.value, 10) || 1) + 1);
			input.dispatchEvent(new Event('change', { bubbles: true }));
		});
	}

	function webformMediaBleed() {
		if (!document.body.classList.contains('page-node-type-webform')) {
			return;
		}
		if (!document.querySelector('.webform-node--bleed')) {
			return;
		}
		updateWebformMediaBleedingRight();
		window.addEventListener('resize', updateWebformMediaBleedingRight);
	}

	function updateWebformMediaBleedingRight() {
		const mediaElements = document.querySelectorAll('.webform-node--bleed .field--name-field-image-contact');
		const layoutElement = document.querySelector('.page-node-type-webform .layout-content');
		const headerElement = document.querySelector('header');
		if (!mediaElements.length || !layoutElement) {
			return;
		}
		mediaElements.forEach(function (mediaElement) {
			mediaElement.style.setProperty('--bleeding-right', '0px');
			mediaElement.style.setProperty('--bleeding-top', '0px');
		});
		const layoutRect = layoutElement.getBoundingClientRect();
		const headerBottom = headerElement ? headerElement.getBoundingClientRect().bottom : 0;
		mediaElements.forEach(function (mediaElement) {
			const mediaRect = mediaElement.getBoundingClientRect();
			const bleedingRight = Math.max(0, Math.round(layoutRect.right - mediaRect.right));
			const bleedingTop = Math.max(0, Math.round(mediaRect.top - headerBottom));
			mediaElement.style.setProperty('--bleeding-right', bleedingRight + 'px');
			mediaElement.style.setProperty('--bleeding-top', bleedingTop + 'px');
		});
	}
})(Drupal, drupalSettings);
